<template>
  <div class="page">
    <div class="ctrl">共 {{ list.length }} 条</div>

    <div class="ctrl" style="margin: 15px">
      <div class="row">
        <div class="col-50">
          <p>姓名：{{ order.name }}</p>
          <p>手机：{{ order.tel }}</p>
          <p>
            微信：<img style="height: 32px" :src="order.headimgurl" alt="" />
            {{ order.nickname }}
          </p>
        </div>
        <div class="col-50">
          <p>订单数量：{{ order.amount }}</p>
          <p>订单金额：{{ order.money }}</p>
          <p>支付状态：{{ order.status == 2 ? "已支付" : "未支付" }}</p>
          <p>支付单号：{{ order.out_trade_no }}</p>
          <p>发货备注：{{ order.remarks }}</p>
        </div>
      </div>
    </div>

    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="goods_thumb" slot-scope="text, record">
        <img style="height: 32px" :src="record.goods_thumb" alt="" />
      </template>
      <template slot="amount" slot-scope="text, record">
        <router-link :to="'/auction/order/goodsList?order_id=' + record.id">
          <a-button size="small">{{ record.amount }}</a-button>
        </router-link>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == -1" color="red">已取消</a-tag>
        <a-tag v-if="record.status == 0" color="orange">未支付</a-tag>
        <a-tag v-if="record.status == 1" color="green">已支付</a-tag>
        <a-tag v-if="record.status == 2" color="orange">已发货</a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-button
          size="small"
          @click="
            fahuoModal.show = true;
            fahuoModal.order_id = record.id;
          "
          >发货</a-button
        >
      </template>
    </a-table>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "图片",
    scopedSlots: {
      customRender: "goods_thumb",
    },
  },
  {
    title: "名称",
    dataIndex: "goods_name",
  },
  {
    title: "编号",
    dataIndex: "goods_sn",
  },
  {
    title: "出价",
    dataIndex: "price",
  },
  {
    title: "最后出价时间",
    dataIndex: "created_at",
  },
];
export default {
  data() {
    return {
      order_id: null,
      columns,
      order: {},
      list: [],
    };
  },
  created() {
    this.order_id = this.$route.query.order_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get(
        "/auction/order/goods/getList?order_id=" + this.order_id
      );

      if (r.status == 1) {
        this.list = r.list;
        this.order = r.order;
      }
    },
  },
};
</script>